/* ==========================================================================
   RORO - Motor del carrusel de producto
   --------------------------------------------------------------------------
   Un unico archivo para todas las instancias del carrusel de producto
   (`sections/new-arrivals-carousel.liquid`: presets New Arrivals y Best
   Sellers). Cada `[data-na-root]` se inicializa por separado, asi que dos
   secciones en la misma pagina no se pisan.

   Contiene:
     - Drag con cursor + inercia en desktop, swipe nativo en movil
     - Indicador de progreso del scroll (linea, flechas opcionales)
     - Slideshow de imagenes en hover, con barra de tiempo sincronizada
     - Quick-add en bottom sheet contra /cart/add.js

   Las rutas del carrito y los textos llegan por atributos `data-` y por los
   <script type="application/json"> que renderiza Liquid: aqui no hay ninguna
   cadena visible ni ninguna URL hardcodeada que dependa del idioma.
   ========================================================================== */

(function () {
  'use strict';

  // Dos instancias de la seccion en la misma pagina emiten dos <script src>
  // identicos y el navegador ejecuta los dos. Con esto el motor se monta una
  // sola vez; el reparto por seccion ya lo hace `data-na-init` en cada root.
  if (window.roroProductCarouselReady) return;
  window.roroProductCarouselReady = true;

  // El precio de la tarjeta lleva a la ficha, como la foto y el nombre (2026-09-27): Clarity grabó
  // toques en el precio que no hacían nada. Delegado en `document` para cubrir también las tarjetas
  // que llegan por scroll. Un arrastre o un swipe no llega aquí: sus oyentes de captura cortan el
  // clic antes. Para teclado y lectores el enlace sigue siendo el nombre.
  document.addEventListener('click', function (event) {
    var price = event.target.closest && event.target.closest('.na-card__price');
    if (!price || event.defaultPrevented) return;
    var card = price.closest('[data-na-card]');
    var link = card && card.querySelector('a.na-card__title');
    if (link) window.location.href = link.href;
  });

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function readJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // El filtro `money` puede devolver entidades (&euro;, &#8364;) según el
  // formato de moneda de la tienda; se decodifican antes de usar textContent.
  var decoder = document.createElement('textarea');
  function money(value) {
    if (!value) return '';
    if (value.indexOf('&') === -1) return value;
    decoder.innerHTML = value;
    return decoder.value;
  }

  /* ==================================================================
     Fallback de color: nombre de opción -> hex, cuando la variante no
     tiene `custom.color_swatch`. Si tampoco hay match, el círculo
     muestra la inicial del nombre en vez de un color plano.
     ================================================================== */
  var COLOR_MAP = {
    white: '#ffffff', blanco: '#ffffff', білий: '#ffffff', белый: '#ffffff',
    ivory: '#fffff0', marfil: '#fffff0', cream: '#fdf6e8', crema: '#fdf6e8', кремовий: '#fdf6e8',
    beige: '#e8dcc8', бежевий: '#e8dcc8',
    nude: '#e3c4ae',
    black: '#000000', negro: '#000000', чорний: '#000000', черный: '#000000',
    grey: '#9a9a9a', gray: '#9a9a9a', gris: '#9a9a9a', сірий: '#9a9a9a', серый: '#9a9a9a',
    silver: '#c9ccce', plata: '#c9ccce', plateado: '#c9ccce', сріблястий: '#c9ccce', срібний: '#c9ccce',
    gold: '#d4af37', dorado: '#d4af37', oro: '#d4af37', золотий: '#d4af37', золото: '#d4af37',
    brown: '#7b5341', marron: '#7b5341', 'marrón': '#7b5341', коричневий: '#7b5341',
    red: '#c0392b', rojo: '#c0392b', червоний: '#c0392b', красный: '#c0392b',
    pink: '#f0b6c4', rosa: '#f0b6c4', рожевий: '#f0b6c4', розовый: '#f0b6c4',
    orange: '#e07a30', naranja: '#e07a30', помаранчевий: '#e07a30',
    yellow: '#e8c547', amarillo: '#e8c547', жовтий: '#e8c547',
    green: '#4a7c59', verde: '#4a7c59', зелений: '#4a7c59', зеленый: '#4a7c59',
    olive: '#6b6b3a', oliva: '#6b6b3a',
    blue: '#3b5b8c', azul: '#3b5b8c', синій: '#3b5b8c', синий: '#3b5b8c',
    'блакитний': '#a8c8e8', 'бірюзовий': '#5fb3ac',
    navy: '#1f2a44',
    purple: '#6b4c8a', morado: '#6b4c8a', 'фіолетовий': '#6b4c8a',
    lilac: '#c5b3d9', 'бузковий': '#c5b3d9',
    lemon: '#f2e06a', 'лимонний': '#f2e06a',
    lime: '#b5d44a', 'лаймовий': '#b5d44a',
    honey: '#d9a441', 'медовий': '#d9a441',
    mint: '#a9d9c2', "м'ятний": '#a9d9c2',
    peach: '#f2c6a0', 'персиковий': '#f2c6a0'
  };

  function resolveColor(name) {
    if (!name) return '';
    var key = String(name).toLowerCase().trim();
    if (COLOR_MAP[key]) return COLOR_MAP[key];
    // Coincidencia parcial: "Nº 60 Cerisier" / "Білий перловий"
    var words = key.split(/[\s,/·\-]+/);
    for (var i = 0; i < words.length; i++) {
      if (COLOR_MAP[words[i]]) return COLOR_MAP[words[i]];
    }
    for (var k in COLOR_MAP) {
      if (key.indexOf(k) !== -1) return COLOR_MAP[k];
    }
    return '';
  }

  function initial(name) {
    return name ? String(name).trim().charAt(0) : '';
  }

  // root -> función que relee su JSON de productos. Ver `refresh()` más abajo.
  var REFRESHERS = new WeakMap();

  function initRoot(root) {
    if (!root || root.dataset.naInit === 'true') return;
    root.dataset.naInit = 'true';

    var SECTION_ID = root.dataset.sectionId || '';

    var ROUTES = {
      add: root.dataset.naAddUrl || '/cart/add.js',
      cart: root.dataset.naCartUrl || '/cart.js'
    };

    var track = root.querySelector('[data-na-track]');
    var carousel = root.querySelector('[data-na-carousel]');
    var sheet = root.querySelector('[data-na-sheet]') || (SECTION_ID ? document.getElementById('NaSheet-' + SECTION_ID) : null);
    var panel = sheet && sheet.querySelector('[data-na-sheet-panel]');

    function moveSheetToBody() {
      if (sheet && sheet.parentElement !== document.body) {
        document.body.appendChild(sheet);
      }
    }

    moveSheetToBody();

    var PRODUCTS = [];
    var STRINGS = readJSON(root.querySelector('[data-na-sheet-strings]')) || {};

    var BY_ID = {};

    /* ---- Swatches de las tarjetas sin metafield ---- */
    function paintSwatches() {
      root.querySelectorAll('[data-na-swatch]').forEach(function (el) {
        if (el.style.getPropertyValue('--na-swatch')) return;
        var hex = resolveColor(el.getAttribute('data-na-swatch-name'));
        if (hex) {
          el.style.setProperty('--na-swatch', hex);
          el.classList.remove('na-card__swatch--fallback');
        } else {
          // En el punto, no en el enlace: el enlace lleva además la etiqueta
          // para lectores de pantalla y un `textContent` se la llevaría por
          // delante.
          var dot = el.querySelector('.na-card__swatch-dot') || el;
          dot.textContent = initial(el.getAttribute('data-na-swatch-name'));
        }
      });
    }

    /* Releer el JSON de productos y repintar los swatches de las tarjetas que
       haya ahora mismo en el DOM. La wishlist repinta su rejilla entera cuando
       otra pestaña cambia la lista, y ahí no se puede volver a llamar a
       `initRoot`: los listeners se registrarían dos veces y cada «añadir al
       carrito» metería dos unidades. */
    function refresh() {
      PRODUCTS = readJSON(root.querySelector('[data-na-products]')) || [];
      BY_ID = {};
      PRODUCTS.forEach(function (p) { BY_ID[String(p.id)] = p; });
      paintSwatches();
      initSlideIndicators();
    }

    REFRESHERS.set(root, refresh);
    refresh();

    /* ==================================================================
       SLIDESHOW DE HOVER — recorre las imágenes del producto mientras el
       cursor está encima.

       UN SOLO RELOJ. La barra de progreso es el temporizador: se anima de
       scaleX(0) a scaleX(1) durante `duration` ms y el cambio de imagen
       cuelga de su `onfinish`. No hay un setInterval para la imagen y una
       animación aparte para la barra — con dos relojes se desincronizan en
       cuanto el navegador se salta un frame. El ciclo es:

         barra a 0 → la barra avanza → llega al 100% → cambia la imagen →
         barra a 0 → ...

       La duración sale de un único sitio: el setting «Time per image» de la
       sección, que Liquid escribe en `data-na-slide-duration`. Cambiarlo ahí
       mueve la barra y el cambio de imagen a la vez, por construcción.

       Dos capas <img> por tarjeta, creadas en el primer hover: permiten el
       crossfade entre imagen N y N+1 (con una sola capa el `src` cambiaría de
       golpe a partir de la segunda foto). No se renderizan desde Liquid, así
       que las imágenes extra solo se descargan del producto que se mira.

       Estado por tarjeta en un WeakMap — `currentImage + progress + timer`
       propios. Dos tarjetas en hover van por libre; no hay estado global.
       ================================================================== */
    var slideState = new WeakMap();
    var playing = new Set();

    function readAttrJSON(el, name) {
      var raw = el.getAttribute(name);
      if (!raw) return null;
      try { return JSON.parse(raw); } catch (e) { return null; }
    }

    /**
     * ¿El estado guardado ya no describe a la tarjeta que hay en pantalla?
     *
     * Tras un repintado por Section Rendering API, `morph` REUTILIZA el mismo
     * <article> para OTRO producto: le reescribe `src`, precio y
     * `data-na-slides`, le quita las clases que puso el JS y se lleva por
     * delante las dos capas <img> del crossfade, que no existen en el HTML del
     * servidor. Lo único que sobrevive es este WeakMap, y sigue apuntando a las
     * fotos del producto anterior y a dos capas ya desconectadas del DOM.
     *
     * Sin este chequeo la tarjeta se queda anunciando varias fotos (la barrita
     * de posición) y ni el swipe ni el hover pintan ninguna.
     */
    function slideStateIsStale(card, state) {
      if (!state || !state.slides || !state.slides.length) return false;

      var media = card.querySelector('[data-na-slides]');
      if (!media || media.getAttribute('data-na-slides') !== state.raw) return true;

      // Mismas fotos, pero morph ya se llevó las capas: hay que rehacerlas.
      return !state.layers || !state.layers[0] || !state.layers[0].isConnected;
    }

    /** Deja la tarjeta como recién llegada del servidor. */
    function dropSlideState(card, state) {
      playing.delete(card);

      if (state.anim) {
        state.anim.onfinish = null;
        state.anim.cancel();
        state.anim = null;
      }

      if (state.layers) {
        state.layers.forEach(function (layer) {
          if (layer.parentNode) layer.parentNode.removeChild(layer);
        });
      }

      var dots = card.querySelector('.na-card__dots');
      if (dots && dots.parentNode) {
        dots.parentNode.removeChild(dots);
      }

      slideState.delete(card);
      card.classList.remove('na-card--slideshow');
      card.classList.remove('na-card--playing');
      card.classList.remove('na-card--has-multi-slides');
    }

    function slideSetup(card) {
      var state = slideState.get(card);
      if (state && slideStateIsStale(card, state)) {
        dropSlideState(card, state);
        state = null;
      }
      if (state) return state;

      state = { slides: [] };
      slideState.set(card, state);

      var media = card.querySelector('[data-na-slides]');
      if (!media) return state;

      var slides = readAttrJSON(media, 'data-na-slides');
      if (!Array.isArray(slides) || slides.length < 2) return state;

      var progress = card.querySelector('[data-na-progress-bar]');
      // Sin Web Animations API no hay forma de que la barra y la imagen
      // compartan reloj: la tarjeta se queda con el swap de dos imágenes por
      // CSS, que es un degradado aceptable, no un error.
      if (!progress || typeof progress.animate !== 'function') return state;

      state.slides = slides;
      state.card = card;
      // Huella del producto que describe este estado. Ver `slideStateIsStale`.
      state.raw = media.getAttribute('data-na-slides');
      state.media = media;
      state.progress = progress;
      state.index = 0;
      state.layers = null;
      state.slot = 0;
      state.anim = null;
      // Sube en cada start/stop. Sirve para descartar los `transitionend` de
      // un ciclo ya abandonado, que si no apagarían una capa recién mostrada.
      state.gen = 0;
      state.duration = parseInt(card.getAttribute('data-na-slide-duration'), 10) || 800;

      card.classList.add('na-card--slideshow');
      return state;
    }

    function ensureLayers(card, state) {
      if (state.layers) return state.layers;

      var host = card.querySelector('.na-card__media-link') || state.media;
      state.layers = [0, 1].map(function () {
        var layer = document.createElement('img');
        layer.className = 'na-card__slide';
        layer.setAttribute('alt', '');
        layer.setAttribute('aria-hidden', 'true');
        layer.setAttribute('draggable', 'false');
        layer.decoding = 'async';
        host.appendChild(layer);
        return layer;
      });
      return state.layers;
    }

    function ensureDots(card, state) {
      if (!card || !state || !state.slides || state.slides.length < 2) return;
      var media = card.querySelector('.na-card__media');
      if (!media) return;
      var dotsContainer = media.querySelector('.na-card__dots');
      if (!dotsContainer) {
        dotsContainer = document.createElement('div');
        dotsContainer.className = 'na-card__dots';
        dotsContainer.setAttribute('aria-hidden', 'true');
        for (var i = 0; i < state.slides.length; i++) {
          var dot = document.createElement('span');
          dot.className = 'na-card__dot' + (i === state.index ? ' is-active' : '');
          dot.setAttribute('data-na-dot-index', i);
          dotsContainer.appendChild(dot);
        }
        media.appendChild(dotsContainer);
      }
    }

    function preload(url) {
      if (!url) return;
      var img = new Image();
      img.decoding = 'async';
      img.src = url;
    }

    /**
     * Funde la capa libre por encima de la que está visible. La saliente se
     * apaga cuando la entrante ha terminado de aparecer (`transitionend`, no
     * un temporizador nuevo), y así queda ya a opacidad 0 y lista para el
     * ciclo siguiente.
     */
    function crossfadeTo(state, url) {
      var incoming = state.layers[state.slot];
      var outgoing = state.layers[1 - state.slot];
      var gen = state.gen;

      incoming.src = url;
      incoming.style.zIndex = '2';
      outgoing.style.zIndex = '1';
      incoming.classList.add('is-visible');

      if (outgoing.classList.contains('is-visible')) {
        incoming.addEventListener('transitionend', function handler(event) {
          if (event.propertyName !== 'opacity') return;
          incoming.removeEventListener('transitionend', handler);
          if (state.gen !== gen) return;
          outgoing.classList.remove('is-visible');
        });
      }

      state.slot = 1 - state.slot;
    }

    /** Arranca la barra desde 0. Al llenarse, y solo entonces, pasa de imagen. */
    function slideStep(card, state) {
      if (state.anim) {
        state.anim.onfinish = null;
        state.anim.cancel();
      }

      // Sin `fill`: al terminar, la barra vuelve sola a su `scaleX(0)` de CSS,
      // que es exactamente el reset que toca antes del ciclo siguiente. Con
      // `fill: forwards` se quedaría clavada al 100% y además cada ciclo
      // dejaría una animación viva retenida en el elemento.
      state.anim = state.progress.animate(
        [{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }],
        { duration: state.duration, easing: 'linear' }
      );

      state.anim.onfinish = function () {
        if (!playing.has(card)) return;
        state.index = (state.index + 1) % state.slides.length;
        slideShow(card, state);
      };
    }

    function slideShow(card, state) {
      crossfadeTo(state, state.slides[state.index]);
      preload(state.slides[(state.index + 1) % state.slides.length]);
      slideStep(card, state);
    }

    function slideStart(card) {
      if (reducedMotion.matches) return;
      if (playing.has(card)) return;

      var state = slideSetup(card);
      if (state.slides.length < 2) return;

      playing.add(card);
      card.classList.add('na-card--playing');
      state.gen++;
      state.index = 0;
      state.slot = 0;
      ensureLayers(card, state);
      preload(state.slides[1]);

      // La imagen 1 ya está puesta (es la <img> principal de la tarjeta), así
      // que el hover solo arranca la barra: cuando se llene, entra la 2.
      slideStep(card, state);
    }

    function slideStop(card) {
      if (!playing.has(card)) return;
      playing.delete(card);

      var state = slideState.get(card);
      card.classList.remove('na-card--playing');
      if (!state) return;

      state.gen++;
      if (state.anim) {
        state.anim.onfinish = null;
        state.anim.cancel();
        state.anim = null;
      }
      state.index = 0;
      state.slot = 0;
      if (state.layers) {
        state.layers.forEach(function (layer) {
          layer.classList.remove('is-visible');
        });
      }
    }

    function slideStopAll() {
      Array.prototype.slice.call(playing).forEach(slideStop);
    }

    /**
     * Vista previa al pasar el cursor por un círculo: se enseña la foto de ESE
     * color sin salir del listado. La capa la monta `prefetchPreviews()` al
     * entrar en la tarjeta, así que una tarjeta que nadie toca no descarga
     * ninguna imagen de más.
     *
     * Vale para los DOS tipos de círculo, porque los dos llevan el mismo
     * `data-na-preview-img`: el de familia (cada color es otro producto) y el de
     * variante (Брязкальце Charm, My Teddy Friend). Antes solo miraba el de
     * familia, así que en la mitad del catálogo el hover no hacía nada.
     *
     * Solo con ratón: en móvil el círculo de familia es un enlace y se toca.
     */
    function previewLayer(swatch) {
      var card = swatch.closest('[data-na-card]');
      var url = swatch.getAttribute('data-na-preview-img');
      if (!card || !url) return null;

      var host = card.querySelector('.na-card__media-link');
      if (!host) return null;

      var layer = card.querySelector('.na-card__family-preview');
      if (!layer) {
        layer = document.createElement('img');
        layer.className = 'na-card__family-preview';
        layer.setAttribute('alt', '');
        layer.setAttribute('aria-hidden', 'true');
        layer.setAttribute('draggable', 'false');
        // `sync` y no `async`: la foto ya está en caché desde que el cursor
        // entró en la tarjeta, y decodificarla en el hilo principal en ese
        // momento es más rápido que esperar a un frame posterior.
        layer.decoding = 'sync';
        layer.fetchPriority = 'high';
        host.appendChild(layer);
      }

      if (layer.getAttribute('src') !== url) layer.setAttribute('src', url);
      return layer;
    }

    /**
     * Las fotos de los círculos se piden al entrar en la TARJETA, no al llegar
     * al círculo. Entre una cosa y la otra hay bastante recorrido de ratón, y
     * en ese hueco cabe entera la descarga; pidiéndolas al llegar al círculo,
     * el primer hover de cada color enseñaba la foto tarde y se notaba.
     *
     * Se hace una sola vez por tarjeta y solo con ratón, así que una tarjeta
     * que nadie toca (y todo el móvil) no descarga ni un byte de más.
     */
    function prefetchPreviews(card) {
      if (!card || card.dataset.naPrefetched === 'true') return;

      var swatches = card.querySelectorAll('[data-na-preview-img]');
      if (!swatches.length) return;

      card.dataset.naPrefetched = 'true';

      // La capa se monta ya: así el primer hover solo cambia `src` sobre un
      // nodo que el navegador ya tiene colocado y compuesto.
      previewLayer(swatches[0]);

      Array.prototype.forEach.call(swatches, function (el) {
        var url = el.getAttribute('data-na-preview-img');
        if (!url) return;
        var img = new Image();
        img.decoding = 'async';
        img.src = url;
      });
    }

    // Va ANTES que el resto de handlers de hover: cuando el cursor entra en la
    // tarjeta directamente sobre un círculo, la descarga tiene que estar pedida
    // antes de que corra el handler que enseña la capa.
    root.addEventListener('pointerover', function (event) {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      prefetchPreviews(event.target.closest('[data-na-card]'));
    });

    root.addEventListener('pointerover', function (event) {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      var swatch = event.target.closest('[data-na-preview-img]');
      if (!swatch) return;

      var layer = previewLayer(swatch);
      if (layer) layer.classList.add('is-visible');

      // Mientras se mira un color concreto, el slideshow de la tarjeta sobra:
      // la barra de progreso corriendo compite con la foto que se esta pidiendo.
      var card = swatch.closest('[data-na-card]');
      if (card) slideStop(card);
    });

    root.addEventListener('pointerout', function (event) {
      var swatch = event.target.closest('[data-na-preview-img]');
      if (!swatch || swatch.contains(event.relatedTarget)) return;

      var card = swatch.closest('[data-na-card]');
      var layer = card && card.querySelector('.na-card__family-preview');
      if (layer) layer.classList.remove('is-visible');

      // Al salir del circulo, si el cursor sigue dentro de la tarjeta y no ha
      // entrado en otro circulo, el slideshow vuelve a arrancar.
      var haciaOtroSwatch = event.relatedTarget && event.relatedTarget.closest
        && event.relatedTarget.closest('[data-na-preview-img]');
      if (card && !haciaOtroSwatch && card.contains(event.relatedTarget)) {
        slideStart(card);
      }
    });

    // Delegación sobre la sección: dos listeners para todas las tarjetas.
    // `pointerover`/`pointerout` sí burbujean (a diferencia de enter/leave) y el
    // filtro por `relatedTarget` descarta el movimiento dentro de la propia card.
    root.addEventListener('pointerover', function (event) {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      // Sobre un circulo de color no: ahi manda la vista previa de ese color.
      // Va aqui y no en el handler del circulo porque si se entra a la tarjeta
      // directamente sobre el circulo, este listener correria despues y la
      // volveria a arrancar.
      if (event.target.closest('[data-na-preview-img]')) return;
      var card = event.target.closest('[data-na-card]');
      if (!card || card.contains(event.relatedTarget)) return;
      slideStart(card);
    });

    root.addEventListener('pointerout', function (event) {
      var card = event.target.closest('[data-na-card]');
      if (!card || card.contains(event.relatedTarget)) return;
      slideStop(card);
    });

    // Nada debe seguir animando con la pestaña en segundo plano.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) slideStopAll();
    });

    function updateCardIndicator(state) {
      if (!state || !state.slides || state.slides.length < 2) return;
      if (state.progress) {
        var total = state.slides.length;
        var pct = 100 / total;
        state.progress.style.setProperty('--na-line-width', pct + '%');
        state.progress.style.setProperty('--na-line-x', (state.index * 100) + '%');
      }
      var card = state.card || (state.media && state.media.closest('[data-na-card]'));
      if (card) {
        var dots = card.querySelectorAll('.na-card__dot');
        if (dots.length) {
          for (var i = 0; i < dots.length; i++) {
            dots[i].classList.toggle('is-active', i === state.index);
          }
        }
      }
    }

    function initCardSlideState(card) {
      var state = slideState.get(card);
      if (state && slideStateIsStale(card, state)) {
        dropSlideState(card, state);
        state = null;
      }
      if (state && state.slides && state.slides.length) return state;
      state = slideSetup(card);
      if (state && state.slides && state.slides.length >= 2) {
        ensureLayers(card, state);
        ensureDots(card, state);
        updateCardIndicator(state);
      }
      return state;
    }

    var isMobileGridSection = root.classList.contains('na-section--mobile-grid');

    /**
     * Indicador de multi-imagen SOLO en secciones grid en movil (New Arrivals),
     * nunca en carruseles (Best Sellers).
     *
     * Es una funcion y la llama tambien `refresh()` porque hay listados que
     * anaden tarjetas DESPUES del arranque: el scroll infinito del constructor
     * de sets de /pages/podarunky. Sin esto, una tarjeta traida por scroll se
     * quedaba sin puntos. El guardia de `slideState` existe porque `refresh()`
     * corre una vez antes de que esas variables esten asignadas.
     */
    function initSlideIndicators() {
      if (!isMobileGridSection || !slideState) return;
      root.querySelectorAll('[data-na-card]').forEach(function (card) {
        /* El flag ya no es un portero, solo evita rehacer trabajo: morph lo
           borra al repintar (no existe en el HTML del servidor), y aun cuando
           sobreviva, `initCardSlideState` detecta por su cuenta que el estado
           quedó viejo. Salir aquí por el flag dejaba tarjetas repintadas sin
           capas hasta que el usuario las tocaba. */
        var state = initCardSlideState(card);
        card.dataset.naSlideInit = 'true';
        if (state && state.slides && state.slides.length >= 2) {
          card.classList.add('na-card--has-multi-slides');
        }
      });
    }

    initSlideIndicators();

    /* Touch Swipe en tarjetas: exclusivo en grid movil */
    var cardTouchStart = { x: 0, y: 0 };
    var cardTouchActive = null;
    var cardTouchSwiped = false;
    var cardTouchDirection = null;

    root.addEventListener('touchstart', function (event) {
      if (!root.classList.contains('na-section--mobile-grid')) return;
      if (event.touches.length !== 1) return;
      if (event.target.closest('[data-na-quick-add], .wishlist-btn, .na-card__swatches, .na-card__family')) return;
      var media = event.target.closest('.na-card__media');
      if (!media) return;
      var card = media.closest('[data-na-card]');
      if (!card) return;
      var state = initCardSlideState(card);
      if (!state || !state.slides || state.slides.length < 2) return;
      cardTouchActive = card;
      cardTouchStart.x = event.touches[0].clientX;
      cardTouchStart.y = event.touches[0].clientY;
      cardTouchSwiped = false;
      cardTouchDirection = null;
    }, { passive: true });

    root.addEventListener('touchmove', function (event) {
      if (!cardTouchActive || event.touches.length !== 1) return;
      var currentX = event.touches[0].clientX;
      var currentY = event.touches[0].clientY;
      var dx = currentX - cardTouchStart.x;
      var dy = currentY - cardTouchStart.y;
      var absX = Math.abs(dx);
      var absY = Math.abs(dy);

      if (!cardTouchDirection) {
        if (absX > 6 || absY > 6) {
          if (absX > absY) {
            cardTouchDirection = 'horizontal';
          } else {
            cardTouchDirection = 'vertical';
            cardTouchActive = null;
            return;
          }
        }
      }

      if (cardTouchDirection === 'horizontal') {
        if (event.cancelable) {
          event.preventDefault();
        }
        if (absX > 10) {
          cardTouchSwiped = true;
        }
      }
    }, { passive: false });

    root.addEventListener('touchend', function (event) {
      if (!cardTouchActive) {
        cardTouchDirection = null;
        return;
      }
      var card = cardTouchActive;
      cardTouchActive = null;
      cardTouchDirection = null;
      if (!cardTouchSwiped) return;

      var touchEnd = event.changedTouches && event.changedTouches[0] ? event.changedTouches[0].clientX : cardTouchStart.x;
      var dx = touchEnd - cardTouchStart.x;
      if (Math.abs(dx) >= 25) {
        var state = slideState.get(card);
        if (state && state.slides && state.slides.length >= 2) {
          state.gen++;
          if (dx < 0) {
            state.index = (state.index + 1) % state.slides.length;
          } else {
            state.index = (state.index - 1 + state.slides.length) % state.slides.length;
          }
          crossfadeTo(state, state.slides[state.index]);
          preload(state.slides[(state.index + 1) % state.slides.length]);
          updateCardIndicator(state);
        }
      }

      setTimeout(function () {
        cardTouchSwiped = false;
      }, 350);
    });

    root.addEventListener('touchcancel', function () {
      cardTouchActive = null;
      cardTouchDirection = null;
      cardTouchSwiped = false;
    });

    root.addEventListener('click', function (event) {
      if (cardTouchSwiped) {
        event.preventDefault();
        event.stopPropagation();
        cardTouchSwiped = false;
      }
    }, true);

    /* ==================================================================
       CARRUSEL — drag con cursor + inercia (desktop), swipe nativo (mobile)
       ================================================================== */
    var dragEnabled = root.dataset.naDrag === 'true';
    var down = false;
    var moved = false;
    var suppressClick = false;
    var startX = 0;
    var startScroll = 0;
    var lastX = 0;
    var lastT = 0;
    var velocity = 0;
    var inertiaId = null;

    if (track && dragEnabled) {
      track.classList.add('is-draggable');

      track.addEventListener('pointerdown', function (event) {
        // El táctil usa el scroll nativo del navegador: se siente como un feed.
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        down = true;
        moved = false;
        suppressClick = false;
        startX = event.clientX;
        lastX = event.clientX;
        lastT = performance.now();
        velocity = 0;
        startScroll = track.scrollLeft;
        if (inertiaId) cancelAnimationFrame(inertiaId);
      });

      window.addEventListener('pointermove', function (event) {
        if (!down) return;
        var dx = event.clientX - startX;
        if (!moved && Math.abs(dx) > 4) {
          moved = true;
          track.classList.add('is-dragging');
          slideStopAll();
        }
        if (!moved) return;

        event.preventDefault();
        track.scrollLeft = startScroll - dx;

        var now = performance.now();
        var dt = now - lastT;
        if (dt > 0) {
          velocity = ((event.clientX - lastX) / dt) * 16;
          lastX = event.clientX;
          lastT = now;
        }
      }, { passive: false });

      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);

      // Evita el drag nativo de imágenes/enlaces del navegador.
      track.addEventListener('dragstart', function (event) { event.preventDefault(); });
    }

    function endDrag() {
      if (!down) return;
      down = false;
      track.classList.remove('is-dragging');
      if (!moved) return;
      suppressClick = true;
      startInertia();
    }

    function startInertia() {
      var v = velocity;
      if (Math.abs(v) < 0.6) return;
      var step = function () {
        v *= 0.94;
        track.scrollLeft -= v;
        if (Math.abs(v) > 0.4) inertiaId = requestAnimationFrame(step);
      };
      inertiaId = requestAnimationFrame(step);
    }

    // Un arrastre no debe abrir la PDP ni el quick-add.
    if (track) {
      track.addEventListener('click', function (event) {
        if (!suppressClick) return;
        suppressClick = false;
        event.preventDefault();
        event.stopPropagation();
      }, true);
    }

    /* ---- Barra de progreso y flechas ---- */
    var prevBtn = root.querySelector('[data-na-arrow="prev"]');
    var nextBtn = root.querySelector('[data-na-arrow="next"]');
    var progressBar = root.querySelector('[data-na-progressbar]');
    var progressThumb = root.querySelector('[data-na-progress-thumb]');
    var controlsTicking = false;

    function updateControls() {
      if (!track) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var ratio = maxScroll > 0 ? (track.scrollLeft / maxScroll) : 0;
      ratio = Math.max(0, Math.min(1, ratio));

      if (progressThumb) {
        var visibleRatio = track.scrollWidth > 0 ? (track.clientWidth / track.scrollWidth) : 0.25;
        var thumbWidthPct = Math.max(15, Math.min(50, visibleRatio * 100));
        var availableTravel = 100 - thumbWidthPct;
        progressThumb.style.width = thumbWidthPct + '%';
        progressThumb.style.left = (ratio * availableTravel) + '%';
        if (progressBar) progressBar.setAttribute('aria-valuenow', String(Math.round(ratio * 100)));
      }

      if (prevBtn) {
        var atStart = track.scrollLeft <= 2;
        prevBtn.disabled = atStart;
        prevBtn.setAttribute('aria-disabled', String(atStart));
      }
      if (nextBtn) {
        var atEnd = track.scrollLeft >= maxScroll - 2;
        nextBtn.disabled = atEnd;
        nextBtn.setAttribute('aria-disabled', String(atEnd));
      }
    }

    if (track) {
      track.addEventListener('scroll', function () {
        if (controlsTicking) return;
        controlsTicking = true;
        requestAnimationFrame(function () {
          updateControls();
          controlsTicking = false;
        });
      }, { passive: true });

      window.addEventListener('resize', updateControls);
      updateControls();

      if (progressBar) {
        progressBar.addEventListener('click', function (e) {
          var rect = progressBar.getBoundingClientRect();
          var clickRatio = (e.clientX - rect.left) / rect.width;
          clickRatio = Math.max(0, Math.min(1, clickRatio));
          var maxScroll = track.scrollWidth - track.clientWidth;
          track.scrollTo({ left: clickRatio * maxScroll, behavior: 'smooth' });
        });
      }

      [prevBtn, nextBtn].forEach(function (btn) {
        if (!btn) return;
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-na-arrow') === 'prev' ? -1 : 1;
          track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
        });
      });
    }

    /* ==================================================================
       BOTTOM SHEET — quick add
       ================================================================== */
    if (!sheet || !panel) return;

    var refs = {
      overlay: sheet.querySelector('[data-na-sheet-overlay]'),
      close: sheet.querySelector('[data-na-sheet-close]'),
      mediaLink: sheet.querySelector('[data-na-sheet-media-link]'),
      image: sheet.querySelector('[data-na-sheet-image]'),
      prevImage: sheet.querySelector('[data-na-sheet-prev]'),
      nextImage: sheet.querySelector('[data-na-sheet-next]'),
      category: sheet.querySelector('[data-na-sheet-category]'),
      title: sheet.querySelector('[data-na-sheet-title]'),
      titleLink: sheet.querySelector('[data-na-sheet-title-link]'),
      price: sheet.querySelector('[data-na-sheet-price]'),
      priceLink: sheet.querySelector('[data-na-sheet-price-link]'),
      compare: sheet.querySelector('[data-na-sheet-compare]'),
      options: sheet.querySelector('[data-na-sheet-options]'),
      stock: sheet.querySelector('[data-na-sheet-stock]'),
      atc: sheet.querySelector('[data-na-sheet-atc]'),
      atcText: sheet.querySelector('[data-na-atc-text]'),
      atcSep: sheet.querySelector('[data-na-atc-sep]'),
      atcPrice: sheet.querySelector('[data-na-atc-price]'),
      feedback: sheet.querySelector('[data-na-sheet-feedback]'),
      warranty: sheet.querySelector('[data-na-sheet-warranty]'),
      returns: sheet.querySelector('[data-na-sheet-returns]'),
      postHandle: sheet.querySelector('[data-na-sheet-post-handle]'),
      postHandleText: sheet.querySelector('[data-na-sheet-post-handle-text]'),
      thumb: sheet.querySelector('[data-na-sheet-thumb]'),
      thumbImage: sheet.querySelector('[data-na-sheet-thumb-image]'),
      dot: sheet.querySelector('[data-na-sheet-dot]'),
      qty: sheet.querySelector('[data-na-sheet-qty]'),
      qtyValue: sheet.querySelector('[data-na-qty-value]'),
      qtyBtns: sheet.querySelectorAll('[data-na-qty-step]')
    };

    /* Unidades del quick-add (2026-10-05). Tope y regla del −X% copiados del
       recuadro de la ficha (`QTY_MAX` y `quantityTotals()` en
       `blocks/roro-purchase-panel.liquid`): si se toca uno, mirar el otro. */
    var QTY_MAX = 10;
    var qty = 1;
    var DISC_THRESHOLD = parseInt(STRINGS.discThreshold, 10) || 0;
    var DISC_PCT = parseFloat(STRINGS.discPct) || 0;
    // Piezas que pide el código además del umbral (`gift_pack_discount_min_items`).
    var DISC_MIN_ITEMS = parseInt(STRINGS.discMinItems, 10);
    if (!(DISC_MIN_ITEMS >= 1)) DISC_MIN_ITEMS = 2;

    // Tipos de producto sin garantía de 1 año (ajuste «Без гарантії» del panel).
    var WARRANTY_EXCLUDED = (sheet.getAttribute('data-na-warranty-excluded') || '')
      .split(',')
      .map(function (type) { return type.trim(); })
      .filter(Boolean);

    var current = null;
    var post = null;
    /* Valor elegido de cada opcion, indexado como `variant.options`: 0, 1, 2.
       `null` significa que este producto no tiene ese eje. Antes habia dos
       variables sueltas, selColor y selSize, y un producto cuya unica opcion no
       se llamaba «color» ni «talla» (Комплектація, Ювелірна сталь) no tenia
       donde guardar la eleccion: el sheet no ofrecia nada y anadia al carrito la
       primera variante a ciegas. */
    var selected = [null, null, null];
    var lastFocus = null;

    /* Opciones con mas de un valor, tal y como las serializa
       `snippets/roro-product-card-json.liquid`. El JSON viejo que pueda quedar
       cacheado no las trae: sin ellas el sheet se comporta como un producto de
       variante unica en vez de romperse. */
    function optionsOf(product) {
      return (product && product.options) || [];
    }

    function findVariant() {
      if (!current) return null;
      var opts = optionsOf(current);
      var list = current.variants;
      for (var i = 0; i < list.length; i++) {
        var v = list[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) {
          var idx = opts[j].index;
          if (selected[idx] !== null && v.options[idx] !== selected[idx]) {
            ok = false;
            break;
          }
        }
        if (ok) return v;
      }
      return null;
    }

    function firstAvailable(product) {
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available) return product.variants[i];
      }
      return product.variants[0] || null;
    }

    /* Un valor esta disponible si existe una variante con stock que lo lleve y
       que respete lo elegido en los grupos ANTERIORES. Los posteriores se
       ignoran a proposito: es la cascada de siempre (el color no se tacha porque
       una talla concreta este agotada, la talla si se tacha en ese color). */
    function valueHasStock(groupPos, idx, value) {
      var opts = optionsOf(current);
      return current.variants.some(function (v) {
        if (!v.available) return false;
        if (v.options[idx] !== value) return false;
        for (var j = 0; j < groupPos; j++) {
          var prev = opts[j].index;
          if (selected[prev] !== null && v.options[prev] !== selected[prev]) return false;
        }
        return true;
      });
    }

    /* Al tocar una opcion la combinacion resultante puede no existir (esa talla
       no se hace en el color nuevo). En vez de dejar el boton en «Оберіть
       варіант», se salta a la primera variante real que respeta lo que se acaba
       de tocar y los grupos anteriores. */
    function reconcile(groupPos) {
      if (findVariant()) return;

      var opts = optionsOf(current);
      var match = null;
      var fallback = null;

      for (var i = 0; i < current.variants.length; i++) {
        var v = current.variants[i];
        var ok = true;
        for (var j = 0; j <= groupPos; j++) {
          var idx = opts[j].index;
          if (selected[idx] !== null && v.options[idx] !== selected[idx]) {
            ok = false;
            break;
          }
        }
        if (!ok) continue;
        if (!fallback) fallback = v;
        if (v.available) {
          match = v;
          break;
        }
      }

      var target = match || fallback;
      if (!target) return;
      opts.forEach(function (o) {
        selected[o.index] = target.options[o.index];
      });
    }

    /* `render()` reconstruye los botones, asi que el foco no puede devolverse a
       un nodo guardado: se busca por la posicion del grupo. */
    function refocusGroup(groupPos) {
      var group = refs.options && refs.options.children[groupPos];
      if (!group) return;
      var el = group.querySelector('[aria-checked="true"]');
      if (el) el.focus({ preventScroll: true });
    }

    /* ---- Render ---- */
    function render() {
      var variant = findVariant();

      refs.title.textContent = current.title;
      if (refs.titleLink) refs.titleLink.href = current.url;
      if (refs.mediaLink) refs.mediaLink.href = current.url;
      if (refs.priceLink) refs.priceLink.href = current.url;

      refs.category.textContent = current.category || '';
      refs.category.hidden = !current.category;

      /* Garantía de 1 año salvo en los tipos del ajuste «Без гарантії» y en
         las tarjetas regalo, que enseñan la devolución de 14 días. La misma
         regla que `snippets/roro-warranty-covered.liquid`. */
      if (refs.warranty && refs.returns) {
        var covered = !current.giftCard && WARRANTY_EXCLUDED.indexOf(current.category || '') === -1;
        refs.warranty.hidden = !covered;
        refs.returns.hidden = covered;
      }

      /* En modo post (social proof) la columna grande es la foto del UGC y el
         producto baja a miniatura. Sin post, `image` es la de siempre y las dos
         piezas extra ni existen en el DOM. */
      var productImage = (variant && variant.image) || current.image || '';
      var image = (post && post.image) || productImage;

      refs.image.style.aspectRatio = '';

      if (image) {
        refs.image.src = image;
        refs.image.alt = post && post.handle
          ? post.handle + ', ' + current.title
          : current.title;
      }

      setGallery(current, image);

      if (refs.postHandle) {
        var handle = post ? post.handle : '';
        if (refs.postHandleText) refs.postHandleText.textContent = handle;
        refs.postHandle.hidden = !handle;
      }

      if (refs.dot) {
        var hasDot = !!(post && post.dotX !== null && post.dotY !== null);
        refs.dot.hidden = !hasDot;
        if (hasDot) {
          refs.dot.style.left = post.dotX + '%';
          refs.dot.style.top = post.dotY + '%';
        }
      }

      if (refs.thumb) {
        refs.thumb.hidden = !post || !productImage;
        refs.thumb.href = current.url;
        if (refs.thumbImage && productImage) {
          refs.thumbImage.src = productImage;
          refs.thumbImage.alt = current.title;
        }
      }

      renderPrice(variant);
      renderOptions();
      renderStock(variant);
      renderAtc(variant);
      renderQty();
    }

    /**
     * El total de las unidades elegidas. Una pieza sola va siempre a su
     * precio, aunque pase el umbral (la founder, 2026-10-02); desde 2 unidades
     * y el umbral sale el −X% que luego cobra el carrito con `RORO-NABIR-5`.
     * El tema solo lo anticipa: si este total llega, el subtotal del carrito
     * también, porque nunca es menor.
     */
    function quantityTotals(variant) {
      var unit = (variant && variant.priceCents) || 0;
      var base = unit * qty;
      var reference = Math.max((variant && variant.compareCents) || 0, unit) * qty;
      // Una tarjeta regalo nunca se rebaja: Shopify no le aplica `RORO-NABIR-5`
      // ni la cuenta para su mínimo (probado el 2026-10-06, `docs/negocio.md`).
      var isGiftCard = !!(current && current.giftCard);
      var offer = !isGiftCard && qty >= DISC_MIN_ITEMS && DISC_THRESHOLD > 0 && DISC_PCT > 0 && base >= DISC_THRESHOLD;
      var pay = offer ? base - Math.round((base * DISC_PCT) / 100) : base;
      return { pay: pay, reference: reference, offer: offer };
    }

    /* Respeta el `money_format` de la tienda, como el recuadro de la ficha y
       el set: el total de 2 tazas no puede cambiar de formato respecto al
       precio de 1 que viene ya pasado por `money`. */
    function formatCents(cents) {
      var format = STRINGS.moneyFormat || '';
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents, format || undefined);
      }
      var group = function (value, sep) {
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      };
      var out = format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, name) {
        var parts = (cents / 100).toFixed(2).split('.');
        switch (name) {
          case 'amount_no_decimals':
            return group(Math.round(cents / 100).toString(), ',');
          case 'amount_with_comma_separator':
            return group(parts[0], '.') + ',' + parts[1];
          case 'amount_no_decimals_with_comma_separator':
            return group(Math.round(cents / 100).toString(), '.');
          case 'amount_with_space_separator':
            return group(parts[0], ' ') + ',' + parts[1];
          case 'amount_no_decimals_with_space_separator':
            return group(Math.round(cents / 100).toString(), ' ');
          default:
            return group(parts[0], ',') + '.' + parts[1];
        }
      });
      return money(out) || (cents / 100).toFixed(2);
    }

    /* Con 1 unidad, exactamente lo de siempre (el precio y el tachado que ya
       vienen pasados por `money`). Con más, el total: a pagar, en rojo si lleva
       el −X%, y el de la ficha tachado al lado. */
    function renderPrice(variant) {
      var totals = quantityTotals(variant);
      refs.price.classList.toggle('is-offer', !!variant && totals.offer);

      if (!variant) {
        refs.price.textContent = '';
        refs.compare.hidden = true;
        return;
      }

      if (qty <= 1) {
        refs.price.textContent = money(variant.price);
        if (variant.compare) {
          refs.compare.textContent = money(variant.compare);
          refs.compare.hidden = false;
        } else {
          refs.compare.hidden = true;
        }
        return;
      }

      refs.price.textContent = formatCents(totals.pay);
      refs.compare.textContent = formatCents(totals.reference);
      refs.compare.hidden = totals.reference <= totals.pay;
    }

    function renderQty() {
      if (!refs.qty) return;
      // En modo set las unidades las lleva el panel del set, no este sheet.
      refs.qty.hidden = packMode;
      if (refs.qtyValue) refs.qtyValue.textContent = String(qty);
      refs.qtyBtns.forEach(function (btn) {
        var step = parseInt(btn.getAttribute('data-na-qty-step'), 10);
        btn.disabled = step < 0 ? qty <= 1 : qty >= QTY_MAX;
      });
    }

    refs.qtyBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-na-qty-step'), 10) || 0;
        var next = Math.min(QTY_MAX, Math.max(1, qty + step));
        if (next === qty) return;
        qty = next;
        var variant = findVariant();
        renderPrice(variant);
        renderAtc(variant);
        renderQty();
      });
    });

    /* Un grupo por cada opcion del producto. Circulos con la FOTO del producto
       cuando la opcion es visual (`visual: true` lo decide
       `snippets/roro-option-map.liquid`), pildoras de texto cuando no lo es.
       La foto dentro del circulo es decision de la fundadora: un color plano no
       dice que se esta comprando. */
    function renderOptions() {
      if (!refs.options) return;
      refs.options.textContent = '';

      var opts = optionsOf(current);
      if (!opts.length) return;

      opts.forEach(function (opt, groupPos) {
        var group = document.createElement('div');
        group.className = 'na-sheet__option';

        var head = document.createElement('div');
        head.className = 'na-sheet__option-head';

        var label = document.createElement('span');
        label.className = 'na-sheet__option-label';
        label.textContent = opt.name ? opt.name.replace(/:\s*$/, '') + ':' : '';

        var valueEl = document.createElement('span');
        valueEl.className = 'na-sheet__option-value';
        valueEl.textContent = selected[opt.index] || '';

        head.appendChild(label);
        head.appendChild(valueEl);
        group.appendChild(head);

        var list = document.createElement('div');
        list.className = opt.visual ? 'na-sheet__swatches' : 'na-sheet__sizes';
        list.setAttribute('role', 'radiogroup');
        list.setAttribute('aria-label', opt.name);

        opt.values.forEach(function (val) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.setAttribute('role', 'radio');
          btn.setAttribute('aria-checked', String(val.name === selected[opt.index]));

          var out = !valueHasStock(groupPos, opt.index, val.name);
          if (out) btn.setAttribute('data-unavailable', 'true');

          if (opt.visual) {
            btn.className = 'na-sheet__swatch';
            btn.setAttribute('aria-label', val.name);
            btn.title = val.name;

            var inner = document.createElement('span');
            inner.className = 'na-sheet__swatch-inner';
            // Foto de la variante -> swatch nativo -> mapa de colores por nombre -> inicial.
            if (val.image) {
              inner.style.setProperty('--na-swatch', 'url(' + val.image + ')');
            } else {
              var paint = val.color || resolveColor(val.name);
              if (paint) {
                inner.style.setProperty('--na-swatch', paint);
              } else {
                inner.textContent = initial(val.name);
              }
            }
            btn.appendChild(inner);
          } else {
            btn.className = 'na-sheet__size';
            btn.textContent = val.name;
            if (out) btn.setAttribute('aria-disabled', 'true');
          }

          btn.addEventListener('click', function () {
            selected[opt.index] = val.name;
            reconcile(groupPos);
            render();
            refocusGroup(groupPos);
          });

          list.appendChild(btn);
        });

        group.appendChild(list);
        refs.options.appendChild(group);
      });
    }

    function renderStock(variant) {
      var ok = !!(variant && variant.available);
      refs.stock.classList.toggle('na-sheet__stock--out', !ok);
      refs.stock.querySelector('.na-sheet__stock-text').textContent = ok
        ? STRINGS.inStock
        : STRINGS.soldOut;
    }

    function renderAtc(variant) {
      var ok = !!(variant && variant.available);
      refs.atc.disabled = !ok;
      refs.atcText.textContent = ok ? STRINGS.atc : (variant ? STRINGS.soldOut : STRINGS.selectOption);
      refs.atcSep.hidden = !ok;
      refs.atcPrice.textContent = ok
        ? qty > 1 ? formatCents(quantityTotals(variant).pay) : money(variant.price)
        : '';
    }

    /* ---- Apertura / cierre ---- */

    /* El disparador puede traer contexto extra: la foto y el @usuario de un post
       de Instagram, y la variante que hay que preseleccionar. El carrusel no
       manda ninguno de los tres, asi que sin ellos el sheet se comporta
       exactamente igual que antes. */
    function readPost(trigger) {
      if (!trigger) return null;
      var image = trigger.getAttribute('data-na-post-image');
      var handle = trigger.getAttribute('data-na-post-handle');
      if (!image && !handle) return null;

      // El punto solo viaja si la foto lo lleva: `null` es "esta no tiene".
      var x = trigger.getAttribute('data-na-post-dot-x');
      var y = trigger.getAttribute('data-na-post-dot-y');

      var w = parseFloat(trigger.getAttribute('data-na-post-w'));
      var h = parseFloat(trigger.getAttribute('data-na-post-h'));

      return {
        image: image || '',
        handle: handle || '',
        dotX: x === null ? null : parseFloat(x),
        dotY: y === null ? null : parseFloat(y),
        ratio: w > 0 && h > 0 ? w + ' / ' + h : ''
      };
    }

    function variantById(product, id) {
      if (!id) return null;
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(id)) return product.variants[i];
      }
      return null;
    }

    function open(productId, trigger) {
      var product = BY_ID[String(productId)];
      if (!product) return;

      moveSheetToBody();
      current = product;
      lastFocus = trigger || null;
      post = readPost(trigger);

      var override = trigger ? trigger.getAttribute('data-na-variant') : null;
      var base = variantById(product, override) || firstAvailable(product);
      selected = [null, null, null];
      optionsOf(product).forEach(function (o) {
        selected[o.index] = base ? base.options[o.index] : null;
      });

      // Cada producto empieza en 1 unidad: lo que se eligió para el anterior no viaja.
      qty = 1;

      hideFeedback();
      render();
      slideStopAll();

      sheet.hidden = false;
      document.body.classList.add('roro-sheet-open');
      lockScroll();

      /* Reflow forzado en vez de requestAnimationFrame. El rAF NO se dispara
         cuando el documento no esta pintando (pestana en segundo plano, el
         navegador limitando, o un contenedor sin compositor), y entonces
         `is-open` no llegaba nunca: el sheet quedaba abierto pero invisible,
         con opacity 0 y translateY(100%). Leer offsetHeight fuerza el layout,
         asi la transicion arranca desde el estado cerrado igual que antes,
         pero sin depender de que haya un frame. */
      void sheet.offsetHeight;
      sheet.classList.add('is-open');
      if (refs.close) refs.close.focus();

      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      if (sheet.hidden) return;
      sheet.classList.remove('is-open');
      document.body.classList.remove('roro-sheet-open');
      document.removeEventListener('keydown', onKeydown);
      unlockScroll();

      window.setTimeout(function () {
        sheet.hidden = true;
        if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
        lastFocus = null;
      }, 300);
    }

    var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

    function onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== 'Tab') return;

      // Focus trap básico.
      var items = Array.prototype.filter.call(
        panel.querySelectorAll(FOCUSABLE),
        function (el) { return el.offsetParent !== null; }
      );
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      } else if (!panel.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    }

    function lockScroll() {
      var gap = window.innerWidth - document.documentElement.clientWidth;
      // En `<html>` y no en el body: con `overflow-x: clip` en el html (base.css),
      // `hidden` en el body lo convierte en contenedor de scroll y lo `sticky`
      // (la columna derecha de la ficha) salta a su sitio de arriba del todo.
      document.documentElement.style.overflow = 'hidden';
      if (gap > 0) document.body.style.paddingRight = gap + 'px';
    }

    function unlockScroll() {
      document.documentElement.style.overflow = '';
      document.body.style.paddingRight = '';
    }

    /* ==================================================================
       GALERIA DEL SHEET — pasar las fotos sin salir del quick-add
       ================================================================== */
    var gallery = { list: [], index: 0 };

    /**
     * La primera foto es la que ya se estaba enseñando (la del post en modo
     * UGC, o la de la variante), y detrás van las del producto sin repetirla.
     * Así abrir el sheet se ve igual que antes y las flechas solo añaden.
     */
    function setGallery(current, shown) {
      var list = [];

      function push(url) {
        if (url && list.indexOf(url) === -1) list.push(url);
      }

      push(shown);
      (current.images || []).forEach(push);

      gallery.list = list;
      gallery.index = 0;

      var many = list.length > 1;
      if (refs.prevImage) refs.prevImage.hidden = !many;
      if (refs.nextImage) refs.nextImage.hidden = !many;
    }

    function goToImage(step) {
      if (gallery.list.length < 2) return;
      var total = gallery.list.length;
      gallery.index = (gallery.index + step + total) % total;
      if (refs.image) refs.image.src = gallery.list[gallery.index];
    }

    if (refs.prevImage) {
      refs.prevImage.addEventListener('click', function () { goToImage(-1); });
    }
    if (refs.nextImage) {
      refs.nextImage.addEventListener('click', function () { goToImage(1); });
    }

    /* MODO SET (`data-na-pack-mode`)
       -------------------------------------------------------------------
       Lo enciende `sections/roro-gift-pack-builder.liquid`. Con el modo
       puesto, este sheet deja de ser un quick-add y pasa a ser el SELECTOR DE
       VARIANTE del set: en vez de llamar a /cart/add.js emite
       `roro:pack:add` sobre el root, y quien lo recoge es
       `assets/roro-gift-pack-builder.js`.

       Existe porque el set necesita elegir variante de verdad — esta tienda
       tiene anillos con 9 tallas — y reescribir un segundo selector habria
       sido duplicar el que ya funciona. */
    var packMode = root.dataset.naPackMode === 'true';

    function emitPackAdd(product, variant) {
      if (!product || !variant) return;
      root.dispatchEvent(new CustomEvent('roro:pack:add', {
        bubbles: false,
        detail: { productId: product.id, variantId: variant.id }
      }));
    }

    root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-na-quick-add]');
      if (!btn) return;
      event.preventDefault();

      var productId = btn.getAttribute('data-product-id');

      /* Sin nada que elegir, el sheet solo seria un paso de mas: una chashka
         de variante unica entra en el set con un toque, como en la referencia.
         En cuanto hay dos variantes el sheet vuelve a abrirse. */
      if (packMode) {
        var product = BY_ID[String(productId)];
        if (product && product.variants && product.variants.length === 1) {
          emitPackAdd(product, product.variants[0]);
          return;
        }
      }

      open(productId, btn);
    });

    if (refs.overlay) refs.overlay.addEventListener('click', close);

    /* Puede haber más de un disparador de cierre: la X de la esquina siempre, y
       en el modal de social proof también el «Скасувати» de debajo del botón de
       comprar. `refs.close` sigue siendo la X, que es la que recibe el foco. */
    sheet.querySelectorAll('[data-na-sheet-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    /* ==================================================================
       AÑADIR AL CARRITO — AJAX + actualización del contador del header
       ================================================================== */
    function showFeedback(message, isError) {
      if (!refs.feedback) return;
      refs.feedback.textContent = message;
      refs.feedback.classList.toggle('na-sheet__feedback--error', !!isError);
      refs.feedback.hidden = false;
    }

    function hideFeedback() {
      if (!refs.feedback) return;
      refs.feedback.hidden = true;
      refs.feedback.textContent = '';
    }

    /**
     * El theme (Horizon) actualiza <cart-icon> escuchando `cart:update` con
     * `detail.data.itemCount`. Se emite ese evento real y, además, se escriben
     * los selectores habituales como red de seguridad si el marcado cambiara.
     */
    function notifyCart(cart, variantId, sections) {
      var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart || undefined,
          sourceId: 'new-arrivals-' + SECTION_ID,
          data: {
            source: 'new-arrivals-quick-add',
            itemCount: count === null ? 0 : count,
            variantId: String(variantId),
            didError: false,
            sections: sections
          }
        }
      }));

      if (count === null) return;

      var fallbacks = '[data-cart-count], .cart-count, #cart-icon-bubble, .cart-bubble__text-count';
      document.querySelectorAll(fallbacks).forEach(function (el) {
        // Solo nodos hoja: nunca sobrescribir marcado ajeno.
        if (el.children.length === 0) el.textContent = count < 100 ? String(count) : '99+';
        if (count > 0) el.classList.remove('hidden');
      });
    }

    refs.atc.addEventListener('click', function () {
      var variant = findVariant();
      if (!variant || !variant.available) return;

      // Modo set: la pieza elegida va al panel, no al carrito. El carrito lo
      // vera una sola vez, cuando el cliente pulse «anadir» en el panel.
      if (packMode) {
        emitPackAdd(current, variant);
        close();
        return;
      }

      refs.atc.disabled = true;
      refs.atc.classList.add('is-loading');
      hideFeedback();

      // Se piden las secciones del carrito igual que hace `product-form.js`,
      // para que el drawer del theme pueda re-renderizarse.
      var sectionIds = Array.prototype.map.call(
        document.querySelectorAll('cart-items-component[data-section-id]'),
        function (el) { return el.dataset.sectionId; }
      ).filter(Boolean);

      var body = { items: [{ id: variant.id, quantity: qty }] };
      if (sectionIds.length) body.sections = sectionIds.join(',');

      // Nada de `response.json()` suelto: `/cart/add.js` puede contestar algo
      // que no sea JSON (429 de Shopify, una pagina de error, un cuerpo vacio)
      // y entonces el `catch` pintaba el mensaje INTERNO del motor de JS — en
      // WebKit, «The string did not match the expected pattern». Detalle en
      // `assets/roro-cart-fetch.js`.
      window.RoroCart.post(ROUTES.add, body)
        .then(function (result) {
          if (!result.ok) {
            showFeedback(window.RoroCart.message(result.data, null, STRINGS.error), true);
            return;
          }

          var sections = result.data.sections;

          // Del HTML del cajón que ya trae la respuesta; `/cart.js` solo si no
          // viene. Ver `RoroCart.cartAfterAdd`.
          return window.RoroCart.cartAfterAdd(result).then(function (cart) {
            // Cerrar primero: `notifyCart` emite `cart:update`, que es el
            // evento con el que <cart-drawer-component> se abre solo. Si el
            // sheet sigue abierto, el carrito aparece encima de él.
            close();
            notifyCart(cart, variant.id, sections);
          });
        })
        .catch(function () {
          showFeedback(STRINGS.error, true);
        })
        .then(function () {
          refs.atc.classList.remove('is-loading');
          renderAtc(findVariant());
        });
    });
  }

  function initAll(scope) {
    if (!scope || typeof scope.querySelectorAll !== 'function') return;
    if (scope.matches && scope.matches('[data-na-root]')) initRoot(scope);
    scope.querySelectorAll('[data-na-root]').forEach(initRoot);
  }

  /* La pagina de wishlist pinta sus tarjetas despues (los productos estan en
     localStorage, no en Liquid), asi que necesita arrancar el motor a mano una
     vez ha inyectado las tarjetas y el JSON. Su root lleva `data-na-init="true"`
     para que el arranque automatico de aqui abajo lo salte. */
  window.RoroProductCarousel = {
    init: initAll,
    /**
     * Vuelve a leer `[data-na-products]` de un root ya inicializado y repinta
     * los swatches de sus tarjetas. Para cuando el listado se repinta entero
     * después del arranque (wishlist), sin duplicar listeners.
     * @param {Element} root
     */
    refresh: function (root) {
      var fn = REFRESHERS.get(root);
      if (fn) fn();
    }
  };

  /* Arranque perezoso (2026-10-28): cada root se monta cuando llega a 600px de
     la pantalla, no todos al cargar. En la home eran siete carruseles montados
     en una sola tarea de 160–270 ms (PageSpeed), con lecturas de layout
     forzadas, justo cuando la clienta empieza a tocar. Un root oculto (la
     pestaña «Переглянуті» de la ficha) se monta al enseñarse. `init()` y el
     theme editor siguen montando al momento. Sin IntersectionObserver, como
     antes: todo al cargar. */
  var bootObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          bootObserver.unobserve(entry.target);
          initRoot(entry.target);
        });
      }, { rootMargin: '600px 0px' })
    : null;

  function bootAll(scope) {
    if (!bootObserver) {
      initAll(scope);
      return;
    }
    scope.querySelectorAll('[data-na-root]').forEach(function (root) {
      if (root.dataset.naInit !== 'true') bootObserver.observe(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootAll(document); });
  } else {
    bootAll(document);
  }

  // El theme editor reinyecta la seccion entera al cambiar un setting.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
